<template>
  <div class="v-radio-question-wrap">
    <div class="v-question-title font-size-18 margin-b-8">
      <span class="required" v-if="question.required">*</span>
      {{ question.name }}
    </div>
    <div class="v-radio-group">
      <el-collapse accordion>
      <el-radio-group v-model="valArr" @change="cb">
        
        <div :class="[item.subAnswerList.length >= 1?'margin-tb-5':'margin-tb-24']" v-for="(item, index) in question.answerList" :key="index">
          <div v-if="item.subAnswerList.length < 1">
            <el-radio :label="item.id">{{ item.name }}</el-radio>
            <input class="input-border" type="text" v-if="item.input" :disabled="!item.checked" v-model="item.inputResult" />
          </div>
          <!-- 多级 -->
          <el-collapse-item :title="item.name" :name="index" v-if="item.subAnswerList.length >= 1">
          <div>
            <div class="v-title2 font-size-16 margin-tb-24">{{ item.name }}</div>
            <div class="padding-left-25 margin-tb-24" v-for="(item2, index2) in item.subAnswerList" :key="index2">
              <el-radio :label="item2.id">{{ item2.name }}</el-radio>
              <input class="input-border" type="text" v-if="item2.input" :disabled="!item2.checked" v-model="item2.inputResult" />
            </div>
          </div>
          </el-collapse-item>
        </div>
        
      </el-radio-group>
      </el-collapse>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    questionData: {
      type: [Object],
      default: () => {}
    }
  },
  data() {
    return {
      valArr: '',
      answerList: [],
      question: this.questionData
    }
  },
  watch: {
    questionData() {
      this.question = this.questionData
      this.defaultRadio()
    }
  },
  methods: {
    // eslint-disable-next-line no-unused-vars
    cb(param) {
      this.cancleChecked(this.question)
      let o = this.selectRadio(this.question)
      let p = {}
      p[o.id] = o
      sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(this.question))
      this.$emit('update:answer', p) //传给父组件
    },
    cancleChecked(param) {
      //取消所有选项
      let arr = param.answerList
      // let newArr=arr;
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        let subArr = obj.subAnswerList
        if (subArr.length > 0) {
          for (let j = 0; j < subArr.length; j++) {
            let subObj = subArr[j]
            if (subObj.checked) {
              subObj.checked = false
              subObj.inputResult = ''
              return ''
            }
          }
        } else {
          if (obj.checked) {
            obj.checked = false
            obj.inputResult = ''
            return ''
          }
        }
      }
    },
    selectRadio(param) {
      // 设置选择项
      let _this = this
      let id = _this.valArr
      let arr = param.answerList
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        let subArr = obj.subAnswerList
        if (subArr.length > 0) {
          for (let j = 0; j < subArr.length; j++) {
            let subObj = subArr[j]
            if (subObj.id == id) {
              subObj.checked = true
              return subObj
            }
          }
        } else {
          if (obj.id == id) {
            obj.checked = true
            return obj
          }
        }
      }
    },
    defaultRadio() {
      let _this = this
      let arr = _this.question.answerList
      for (let i = 0; i < arr.length; i++) {
        let obj = arr[i]
        let subArr = obj.subAnswerList
        if (subArr.length > 0) {
          for (let j = 0; j < subArr.length; j++) {
            let subObj = subArr[j]
            if (subObj.checked) {
              _this.valArr = subObj.id
              let o = {}
              o[subObj.id] = subObj
              sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(_this.question))
              this.$emit('update:answer', o)
              return ''
            }
          }
        } else {
          if (obj.checked) {
            _this.valArr = obj.id
            let o = {}
            o[obj.id] = obj
            // if (JSON.stringify(o) !== '{}') {
              sessionStorage.setItem('currentQuestionAnswer', JSON.stringify(_this.question))
              this.$emit('update:answer', o)
            // } else {
            //   sessionStorage.removeItem('currentQuestionAnswer')
            // }
            return ''
          }
        }
      }
    }
  },
  created() {
    this.defaultRadio()
  }
}
</script>
<style lang="stylus" scoped>
.v-radio-question-wrap{
  width 500px
  margin auto  
  .v-question-title{
    text-align left  
  }
}
.required{
    color:red;
    font-size:16px;
}
.margin-tb-24{
  margin:24px 0;
}
.input-border{
  border:1px solid $color-black-15;
  height:20px;
  padding:5px;
}
input:disabled{
  background-color: $color-gray-f5;
  border-color: $color-gray-e5;
}
.padding-left-25{
  padding-left:25px;
}
.margin-tb-5{
  margin:5px 0;
}
.v-radio-group{
  margin-bottom 30px
}
</style>
